import * as core from '../../../../../../../core'

import { query } from './degree-of-change-by-epic.query'

export const RESOURCE = {
  payload: {
    alias: 'degree.of.change.by.epic',
    description: 'Chart view of degree of change by epic',
    name: 'Degree of Change by Epic',
    query,
    variables: [],
  },
  type: core.quiver.Resource.Type.MosaicWidget,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.MosaicWidget>
